import React, { useEffect, useRef } from 'react';
import { QuestionCard, IntroBand } from '../../components';
import { useGetQuestionsFeedInfiniteQuery } from '../../apis';
import { Spinner, SpinnerVariants } from '../../UI';
import { getToken } from '../../utils/auth';

export const Home: React.FC = () => {
  const {
    data,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  } = useGetQuestionsFeedInfiniteQuery();

  const sentinelRef = useRef<HTMLDivElement | null>(null);

  // Load the next page when the bottom sentinel nears the viewport.
  useEffect(() => {
    const el = sentinelRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasNextPage && !isFetchingNextPage) {
          fetchNextPage();
        }
      },
      { rootMargin: '300px' },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

  const questions = data?.pages.flat() ?? [];
  const loggedIn = !!getToken();

  return (
    <>
      {/* Orientation nudge for first-time / logged-out visitors. */}
      {!loggedIn && <IntroBand />}

      {isLoading
        ? <div className='flex justify-center'>
          <Spinner variant={SpinnerVariants.SMALL_CIRCLE} />
        </div>
        : <>
          {questions.length === 0
            ? <div className='text-white mt-app-base text-app-lg flex justify-center'>
              <p>No questions found</p>
            </div>
            : null}

          {questions.map((question) => (
            <QuestionCard data={question} key={question.questionId} />
          ))}

          <div ref={sentinelRef} aria-hidden="true" />

          {isFetchingNextPage
            ? <div className='flex justify-center my-app-base'>
              <Spinner variant={SpinnerVariants.SMALL_CIRCLE} />
            </div>
            : null}
        </>
      }
    </>
  );
};
